// src/pages/BrokerBuilder/BrokerEmailsTable/BrokerEmailsTable.tsx
import React from "react";
import { FormSpy } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { Col, Table } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import RadioButton from "src/components/Form/RadioButtonV2/RadioButton";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import CustomIcon, { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";
import "./BrokerEmailsTable.scss";

type Props = { form: any };

const BrokerEmailsTable: React.FC<Props> = ({ form }) => {
  return (
    <>
      <Table bordered className="broker-emails-table">
        <thead>
          <tr>
            <th>{S.BRO_EMAIL_TYPE_EMAIL}</th>
            <th>{S.BRO_EMAIL_TYPE_PRIMARY}</th>
            <th>{S.BRO_EMAIL_TYPE_ALT}</th>
            <th>{S.BRO_EMAIL_TYPE_CC}</th>
            <th>{S.BRO_EMAIL_TYPE_REQUESTER}</th>
            <th>{S.BRO_EMAIL_TYPE_CASE_STATUS}</th>
            <th>{S.BRO_EMAIL_DELETE}</th>
          </tr>
        </thead>

        <tbody>
          <FieldArray name="emailRows">
            {({ fields }) =>
              fields.map((name, index) => (
                <tr key={`${index}/${fields.length}`}>
                  <td>
                    <TextField name={`${name}.email`} label="" type="email" placeholder={S.BRO_EMAIL_PLACEHOLDER} />
                  </td>

                  <td>
                    <FormSpy subscription={{ values: true }}>
                      {({ values }) => {
                        const emailVal = values.emailRows?.[index]?.email?.trim();
                        const disabled = !emailVal;
                        return (
                          <div className="radio-small-wrapper">
                            <RadioButton name="emailPrimaryIndex" value={`${index}`} label="" disabled={disabled} />
                          </div>
                        );
                      }}
                    </FormSpy>
                  </td>

                  <td>
                    <CheckboxField className="checkbox-field-v2 small-icon" name={`${name}.isSecondary`} label="" />
                  </td>

                  <td>
                    <CheckboxField className="checkbox-field-v2 small-icon" name={`${name}.isCc`} label="" />
                  </td>

                  <td>
                    <CheckboxField className="checkbox-field-v2 small-icon" name={`${name}.isRequester`} label="" />
                  </td>

                  <td>
                    <CheckboxField className="checkbox-field-v2 small-icon" name={`${name}.isCaseStatus`} label="" />
                  </td>

                  <td>
                    <FormSpy subscription={{ values: true }}>
                      {({ values }) => {
                        const primaryIndex = values.emailPrimaryIndex;
                        const isPrimary = String(primaryIndex) === String(index);
                        return (
                          <button
                            type="button"
                            className="remove-affiliate-btn"
                            onClick={() => {
                              const current = values.emailPrimaryIndex;
                              if (String(current) === String(index)) {
                                form.change("emailPrimaryIndex", undefined);
                              }
                              fields.remove(index);
                            }}
                            disabled={isPrimary}
                            aria-label="Delete email row">
                            <CustomIcon name={IconName.DeleteFileGold} size="16px" />
                          </button>
                        );
                      }}
                    </FormSpy>
                  </td>
                </tr>
              ))
            }
          </FieldArray>
        </tbody>
      </Table>

      <Col className="d-flex align-items-center justify-content-end gap-3">
        <button
          type="button"
          className="button-v2 button-v2__white button-v2__secondary-mini"
          onClick={() =>
            form.mutators.push("emailRows", {
              email: "",
              isSecondary: false,
              isCc: false,
              isCaseStatus: false,
              isRequester: false,
            })
          }>
          <span>{S.BRO_EMAIL_ADD}</span>
        </button>
      </Col>
    </>
  );
};

export default BrokerEmailsTable;
